import React, { Component } from "react";
import "./css/interiorPc.css";

import IconBatten from "./src/icon-batten.png";
import IconFloor from "./src/icon-floor.png";
import ArrowDown from "./src/select-down-img.png";
import ResultIcon from "./src/show_result.png";
import CreateButton from "./src/Create.png";
import ArrowResult from "./src/arrow_result.png";

import PanAndZoom from "./PanAndZoomPc";

import ResultListBattenPc from "./ResultListBattenPc";
import ResultListFloorPc from "./ResultListFloorPc";
import TableInformationBatten from "./TableInformationPc";
import ResultScreenPc from "./ResultScreenPc";
import CalculateBatten from "../calculator/batten/calBattenPc";
import CalculateFloor from "../calculator/floor/calFloorPc";
import EcommercePc from "../ecommerce/EcommercePc";

import Axios from "axios";

export default class interiorPc extends Component {
  state = {
    currentMenuSelect: "batten",
    currentEcomSelect: "batten",
    currentBatten: [],
    currentFloor: [],
    dataBatten: [],
    dataFloor: [],
    currentBattenForCal: [],
    currentFloorForCal: [],

    ResultScreen: false,
    InformationBatten: false,
    InformationFloor: false,
    Calculate: false,
    Footer: false,
    Ecommerce: false,
    FirstLoad: true,

    dimensionsOrientation: "not decided yet",
  };

  onSelectBatten = (value) => {
    this.setState({ currentBatten: { ...value } });
    this.setState({ currentBattenForCal: { ...value } });
  };

  onSelectBattenFromSelect = (value) => {
    console.log("onSelectBattenFromSelect ", value);
    const data = this.state.dataBatten.find(
      (xData) => Number(xData.id) === value
    );

    this.setState({ currentBattenForCal: { ...data } });

    if (data.imagelink === "NoImage") {
      const result = this.state.dataBatten.find(
        (xData) =>
          Number(xData.track) === Number(data.track) &&
          xData.imagelink !== "NoImage"
      );

      if (result != null) {
        const newData = { ...data, imagelink: result.imagelink };
        this.setState({ currentBatten: { ...newData } });
      }
    } else {
      this.setState({ currentBatten: { ...data } });
    }
  };

  onSelectFloor = (value) => {
    this.setState({ currentFloor: { ...value } });
    this.setState({ currentFloorForCal: { ...value } });
  };

  onSelectFloorFromSelect = (value) => {
    console.log("onSelectFloorFromSelect ", value);
    const data = this.state.dataFloor.find(
      (xData) => Number(xData.id) === value
    );

    this.setState({ currentFloorForCal: { ...data } });

    if (data.imagelink === "NoImage") {
      const result = this.state.dataFloor.find(
        (xData) =>
          Number(xData.track) === Number(data.track) &&
          xData.imagelink !== "NoImage"
      );

      if (result != null) {
        const newData = { ...data, imagelink: result.imagelink };
        this.setState({ currentFloor: { ...newData } });
      }
    } else {
      this.setState({ currentFloor: { ...data } });
    }
  };

  onResultScreen = () => {
    const prev = this.state.ResultScreen;
    this.setState({ ResultScreen: !prev });
    this.setState({ Footer: prev });

    if (!prev) {
      this.onHideInformation();
      this.setState({ Calculate: false });
      this.setState({ Ecommerce: false });
    }
  };

  onInformationBatten = () => {
    const prev = this.state.InformationBatten;
    this.setState({ InformationBatten: !prev });
  };

  onInformationFloor = () => {
    const prev = this.state.InformationFloor;
    this.setState({ InformationFloor: !prev });
  };

  onCalculateBatten = () => {
    this.setState({ currentMenuSelect: "batten" });
    this.setState({ ResultScreen: false });
    this.onHideInformation();

    this.setState({ Calculate: true });
  };

  onCalculateFloor = () => {
    this.setState({ currentMenuSelect: "floor" });
    this.setState({ ResultScreen: false });
    this.onHideInformation();

    this.setState({ Calculate: true });
  };

  onHideInformation = () => {
    this.setState({ InformationFloor: false });
    this.setState({ InformationBatten: false });
  };

  onHideCalculator = () => {
    this.setState({ Calculate: false });
  };

  onEcommerce = (value) => {
    if (value !== "") this.setState({ currentEcomSelect: value });

    const prev = this.state.Ecommerce;
    this.setState({ Ecommerce: !prev });
  };

  onSetFooter = () => {
    const prev = this.state.Footer;

    this.setState({ Footer: !prev });
  };

  onSetFirstLoad = () => {
    this.setState({ FirstLoad: false });
  };

  async componentDidMount() {
    const batten = await Axios.get(
      "https://www.shera.com/AR/api/?sqli=id,track,name,class,striped,color,size,width,numpersqm,imagelink,iconlink&table=battens"
    );

    this.setState({ dataBatten: batten.data });

    batten.data.map((resultBatten) => {
      if (resultBatten.id === "1") {
        this.setState({ currentBatten: { ...resultBatten } });
        this.setState({ currentBattenForCal: { ...resultBatten } });
      }
      return null;
    });

    const floor = await Axios.get(
      "https://www.shera.com/AR/api/?sqli=id,track,name,class,striped,color,size,width,numpersqm,imagelink,iconlink&table=floors"
    );

    this.setState({ dataFloor: floor.data });

    floor.data.map((result) => {
      if (result.id === "1") {
        this.setState({ currentFloor: { ...result } });
        this.setState({ currentFloorForCal: { ...result } });
      }
      return null;
    });

    if (
      Number(this.container.offsetWidth) / Number(this.container.offsetHeight) >
      1.498829
    ) {
      this.setState({ dimensionsOrientation: "width" });
    } else {
      this.setState({ dimensionsOrientation: "height" });
    }
  }

  render() {
    return (
      <>
        <div
          className={
            this.state.Footer
              ? "interior-pc-main-with-footer"
              : "interior-pc-main-without-footer"
          }
        >
          <div
            className={
              this.state.ResultScreen || this.state.Calculate
                ? "interior-pc-pan-and-zoom-container-unFull"
                : "interior-pc-pan-and-zoom-container-full"
            }
            onMouseDown={this.onSetFirstLoad}
            ref={(el) => (this.container = el)}
          >
            {this.state.ResultScreen || this.state.Calculate ? (
              <div
                className={
                  this.props.currentState
                    ? "pan-pc-main-with-top"
                    : "pan-pc-main"
                }
              >
                <div>
                  <img
                    className="pan-pc-image-top"
                    src={this.state.currentBatten.imagelink}
                    alt="Batten"
                  />
                </div>
                <div>
                  <img
                    className="pan-pc-image-bottom"
                    src={this.state.currentFloor.imagelink}
                    alt="Floor"
                  />
                </div>
              </div>
            ) : (
              <PanAndZoom
                currentBatten={this.state.currentBatten.imagelink}
                currentFloor={this.state.currentFloor.imagelink}
                currentState={this.state.FirstLoad}
                dimensionsOrientation={this.state.dimensionsOrientation}
              />
            )}
          </div>

          <div
            className={
              this.state.ResultScreen || this.state.Calculate
                ? "interior-pc-screen-show"
                : "interior-pc-screen-hide"
            }
          >
            {this.state.ResultScreen ? (
              <>
                <ResultScreenPc
                  onClose={this.onResultScreen}
                  currentBatten={this.state.currentBatten}
                  currentFloor={this.state.currentFloor}
                  dataBatten={this.state.dataBatten}
                  dataFloor={this.state.dataFloor}
                  onEcommerce={this.onEcommerce}
                />
                <EcommercePc
                  currentProduct={
                    this.state.currentEcomSelect === "batten"
                      ? this.state.currentBatten.id
                      : this.state.currentFloor.id
                  }
                  currentEcomSelect={this.state.currentEcomSelect}
                  status={this.state.Ecommerce}
                  onEcommerce={this.onEcommerce}
                />
              </>
            ) : this.state.Calculate ? (
              this.state.currentMenuSelect === "batten" ? (
                <CalculateBatten
                  onClose={this.onHideCalculator}
                  dataBatten={this.state.dataBatten}
                  currentBatten={this.state.currentBattenForCal}
                  onSelect={this.onSelectBattenFromSelect}
                />
              ) : (
                <CalculateFloor
                  onClose={this.onHideCalculator}
                  dataFloor={this.state.dataFloor}
                  currentFloor={this.state.currentFloorForCal}
                  onSelect={this.onSelectFloorFromSelect}
                />
              )
            ) : null}
          </div>

          <div
            className={
              this.state.Calculate
                ? "interior-pc-resultIcon-container-hide"
                : this.state.ResultScreen
                ? "interior-pc-resultIcon-container-unfull"
                : "interior-pc-resultIcon-container-full"
            }
          >
            {this.state.ResultScreen || this.state.Calculate ? null : (
              <div
                className="interior-pc-resultArrow"
                onClick={this.onResultScreen}
              >
                <img
                  className="interior-pc-resultArrow-image"
                  src={ArrowResult}
                  alt=""
                />
              </div>
            )}
            <div
              className="interior-pc-resultIcon"
              onClick={this.onResultScreen}
            >
              <img
                className="interior-pc-resultIcon-image"
                src={ResultIcon}
                alt=""
              />
              <p className="interior-pc-resultIcon-text">
                {this.state.ResultScreen ? "ปิดผลลัพธ์" : "แสดงผลลัพธ์"}
              </p>
            </div>
          </div>

          <div
            className={
              this.state.Calculate
                ? "interior-pc-footer-button-hide"
                : "interior-pc-footer-button-show"
            }
            onClick={this.onSetFooter}
          >
            <img src={CreateButton} alt="" />
            <div className="interior-pc-footer-button-text">
              <div>Create your own style</div>
              <div style={{ fontSize: "0.9rem" }}>
                เลือกเฉดสีที่ใช่สำหรับคุณ
              </div>
            </div>
          </div>
        </div>

        <div
          className={
            this.state.Footer
              ? "interior-pc-information-with-footer"
              : "interior-pc-information-without-footer"
          }
        >
          <div
            className={
              this.state.InformationBatten
                ? "interior-pc-information-container-left-show"
                : "interior-pc-information-container-left-hide"
            }
          >
            <TableInformationBatten
              current={this.state.currentBatten}
              data={this.state.dataBatten}
              onCalculate={this.onCalculateBatten}
            />

            <div className="interior-pc-information-arrow-down-container">
              <img
                className={
                  this.state.InformationBatten
                    ? "interior-pc-information-arrow-down-show"
                    : "interior-pc-information-arrow-down-hide"
                }
                src={ArrowDown}
                onClick={this.onInformationBatten}
                alt=""
              />
            </div>
          </div>
          <div
            className={
              this.state.InformationFloor
                ? "interior-pc-information-container-right-show"
                : "interior-pc-information-container-right-hide"
            }
          >
            <TableInformationBatten
              current={this.state.currentFloor}
              data={this.state.dataFloor}
              onCalculate={this.onCalculateFloor}
            />

            <div className="interior-pc-information-arrow-down-container">
              <img
                className={
                  this.state.InformationFloor
                    ? "interior-pc-information-arrow-down-show"
                    : "interior-pc-information-arrow-down-hide"
                }
                src={ArrowDown}
                onClick={this.onInformationFloor}
                alt=""
              />
            </div>
          </div>
        </div>
        <div
          className={
            this.state.Footer
              ? "interior-pc-footer-show"
              : "interior-pc-footer-hide"
          }
        >
          <div className="interior-pc-footer-menu-container">
            <div className="interior-pc-footer-icon-container">
              <img
                className="interior-pc-footer-icon-left"
                src={IconBatten}
                alt=""
              />
            </div>

            <div className="interior-pc-footer-list-container">
              <ResultListBattenPc
                onSelect={this.onSelectBatten}
                current={this.state.currentBatten}
                info={this.state.InformationBatten}
                onInfo={this.onInformationBatten}
              />
            </div>
          </div>
          <div className="interior-pc-footer-menu-line"></div>
          <div className="interior-pc-footer-menu-container">
            <div className="interior-pc-footer-icon-container">
              <img
                className="interior-pc-footer-icon-right"
                src={IconFloor}
                alt=""
              />
            </div>

            <div className="interior-pc-footer-list-container">
              <ResultListFloorPc
                onSelect={this.onSelectFloor}
                current={this.state.currentFloor}
                info={this.state.InformationFloor}
                onInfo={this.onInformationFloor}
              />
            </div>

            <div className="interior-pc-footer-main-list-container"></div>
          </div>
        </div>

        <div></div>
      </>
    );
  }
}
